import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import {
  fetchSocialLinks,
  updateSocialLinks,
  createSocialLinks,
} from '../../../../../redux/socialSlice';
import { AppDispatch, RootState } from '../../../../../redux/store';

const SocialHandles: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { social, loading } = useSelector((state: RootState) => state.social);

  const [facebook, setFacebook] = useState('');
  const [instagram, setInstagram] = useState('');
  const [twitter, setTwitter] = useState('');
  const [youtube, setYoutube] = useState('');
  const [appStoreId, setAppStoreId] = useState('');
  const [playStoreId, setPlayStoreId] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    dispatch(fetchSocialLinks());
  }, [dispatch]);

  useEffect(() => {
    if (social) {
      setFacebook(social.facebook || '');
      setInstagram(social.instagram || '');
      setTwitter(social.twitter || '');
      setYoutube(social.youtube || '');
      setAppStoreId(social.appStoreId || '');
      setPlayStoreId(social.playStoreId || '');
    }
  }, [social]);

  const handleSave = async () => {
    setSaving(true);
    const data = {
      facebook,
      instagram,
      twitter,
      youtube,
      appStoreId,
      playStoreId,
    };
    if (social?.id) {
      await dispatch(updateSocialLinks({ id: social.id, data }));
    } else {
      await dispatch(createSocialLinks(data));
    }
    setTimeout(() => setSaving(false), 1200);
  };

  return (
    <Box
      sx={{
        maxWidth: 600,
        margin: '0 auto',
        padding: 4,
        background: '#111',
        borderRadius: 4,
        color: '#fff',
        boxShadow: '0 0 20px rgba(147, 51, 234, 0.4)',
      }}
    >
      <Typography variant="h5" sx={{ mb: 3, color: '#b783f1' }}>
        Social & App Store Links
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <TextField
          fullWidth
          value={facebook}
          onChange={(e) => setFacebook(e.target.value)}
          placeholder="https://facebook.com/yourpage"
          InputProps={{
            startAdornment: <FacebookIcon sx={{ mr: 1, color: '#b783f1' }} />,
          }}
          variant="outlined"
          sx={{
            input: { color: '#fff' },
            fieldset: { borderColor: '#b783f1' },
          }}
        />
        <TextField
          fullWidth
          value={instagram}
          onChange={(e) => setInstagram(e.target.value)}
          placeholder="https://instagram.com/yourhandle"
          InputProps={{
            startAdornment: <InstagramIcon sx={{ mr: 1, color: '#b783f1' }} />,
          }}
          variant="outlined"
          sx={{
            input: { color: '#fff' },
            fieldset: { borderColor: '#b783f1' },
          }}
        />
        <TextField
          fullWidth
          value={twitter}
          onChange={(e) => setTwitter(e.target.value)}
          placeholder="https://twitter.com/yourhandle"
          InputProps={{
            startAdornment: <TwitterIcon sx={{ mr: 1, color: '#b783f1' }} />,
          }}
          variant="outlined"
          sx={{
            input: { color: '#fff' },
            fieldset: { borderColor: '#b783f1' },
          }}
        />
        <TextField
          fullWidth
          value={youtube}
          onChange={(e) => setYoutube(e.target.value)}
          placeholder="https://youtube.com/yourchannel"
          InputProps={{
            startAdornment: <YouTubeIcon sx={{ mr: 1, color: '#b783f1' }} />,
          }}
          variant="outlined"
          sx={{
            input: { color: '#fff' },
            fieldset: { borderColor: '#b783f1' },
          }}
        />
        <TextField
          fullWidth
          value={appStoreId}
          onChange={(e) => setAppStoreId(e.target.value)}
          placeholder="Apple App Store ID (e.g. id123456789)"
          InputProps={{
            startAdornment: <AppleIcon sx={{ mr: 1, color: '#b783f1' }} />,
          }}
          variant="outlined"
          sx={{
            input: { color: '#fff' },
            fieldset: { borderColor: '#b783f1' },
          }}
        />
        <TextField
          fullWidth
          value={playStoreId}
          onChange={(e) => setPlayStoreId(e.target.value)}
          placeholder="Google Play Store ID (e.g. com.app.name)"
          InputProps={{
            startAdornment: <AndroidIcon sx={{ mr: 1, color: '#b783f1' }} />,
          }}
          variant="outlined"
          sx={{
            input: { color: '#fff' },
            fieldset: { borderColor: '#b783f1' },
          }}
        />
      </Box>

      <Button
        onClick={handleSave}
        disabled={saving || loading}
        sx={{
          mt: 4,
          background: '#9333ea',
          color: '#fff',
          fontWeight: 'bold',
          '&:hover': {
            background: '#7e22ce',
          },
        }}
        fullWidth
      >
        {saving || loading ? (
          <CircularProgress size={24} sx={{ color: '#fff' }} />
        ) : (
          'Save Changes'
        )}
      </Button>
    </Box>
  );
};

export default SocialHandles;
